import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ApplicationConfig } from '../../config/config';
import { ContentAccessibilityPopup } from '../../model/content/contentAccessibilityPopup.model';
import { CommonService } from '../../services/common.service';

declare let delta: any;

@Component({
  selector: 'ngc-externalsite',
  templateUrl: 'flyout-externalsite.component.html'
})
export class FlyoutExternalsiteComponent implements OnDestroy, AfterViewInit {
  @ViewChild('dialog') dialog;
  hrefUrl: any;
  target: any;
  public timeouts = [];
  axPopupContent: ContentAccessibilityPopup;
  modalOnHiddenSubscription: Subscription;
  modalConfig = {
    animated: false
  };

  constructor(
    public bsModalRef: BsModalRef,
    private cdref: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private elementRef: ElementRef,
    private modalService: BsModalService,
    private config: ApplicationConfig,
    private srv: CommonService
  ) {}

  close() {
    this.bsModalRef.hide();
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
  }

  openInNewTab() {
    const url = this.hrefUrl;
    let openValue;
    if (
      this.target === null ||
      this.target === undefined ||
      this.target === 'undefined'
    ) {
      openValue = '_blank';
    } else {
      openValue = this.target;
    }
    if (isPlatformBrowser(this.platformId)) {
      this.timeouts.push(
        setTimeout(() => {
          this.close();
          window.open(url, openValue);
        }, 200)
      );
    }
  }

  ngAfterViewInit() {
    this.srv.trapFocusInsideModal(this.elementRef);
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  ngOnDestroy() {
    this.stopTimeout();
  }
}
